<template>
    <div class="page">
        <top-banner :img-url="require('../../assets/img/news/newsBanner.jpg')"
                    :pageTitle="$i18n.t('common.媒体报道')"></top-banner>
        <div class="container">
            <section-title :title="$i18n.t('common.媒体报道')"></section-title>
        </div>
        <!--媒体报道轮播-->
        <!--<div class="newsswiper">-->
        <!--<div class="poster"></div>-->
        <!--&lt;!&ndash;内容&ndash;&gt;-->
        <!--<div class="container">-->
        <!--<div class="newsbanner">-->
        <!--<section class="banner">-->
        <!--<swiper :options="bannerSwiperOpts" ref="bannerSwiper" v-if="bannerImgs.length>0">-->
        <!--<swiper-slide v-for="(item,index) in bannerImgs" :key="index" class="banner-item">-->
        <!--<div class="row">-->
        <!--<a :href="item.url" v-if="item.url">-->
        <!--<div class="img" :style="{backgroundImage:'url('+ item.picture+')'}"></div>-->
        <!--</a>-->
        <!--<div class="img" :style="{backgroundImage:'url('+ item.picture+')'}" v-else></div>-->
        <!--<div class="content">-->
        <!--<div class="title">{{item.title}}</div>-->
        <!--<div class="date">{{item.crt_time}}</div>-->
        <!--<div v-html="item.author"></div>-->
        <!--</div>-->

        <!--</div>-->
        <!--</swiper-slide>-->
        <!--</swiper>-->

        <!--</section>-->
        <!--<div class="icon-left icon">-->
        <!--<Icon type="ios-arrow-back"/>-->
        <!--</div>-->
        <!--<div class="icon-right">-->
        <!--<Icon type="ios-arrow-forward"/>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->

        <!--</div>-->

        <!--新闻列表-->
        <div class="container news">
            <ul class="list">
                <item :item="item" :sortNum="item.release_time.slice(8,10)" v-for="(item,index) in newslist" :key="index" class="news-item" :href="'/newsDetail?id='+item.id"></item>
            </ul>
<!--            <Page :total="100" />-->
        </div>
    </div>

</template>

<script>

    import Item from '../../components/list/DateItem'

    export default {
        data() {
            return {
                bannerImgs: [],
                newslist: [],
                "pagination" : {
                    "currentPage" : 0,
                    "rowsCount" : 0,
                    "pageCount" : 1,
                    "rowsPerPage" : 12,
                },
                // bannerSwiperOpts:{
                //     loop: true,
                //     effect:'slide',
                //     speed:800,
                //     observer:true,
                //     observeParents:true,
                //     pagination: {
                //         el: ".swiper-pagination",
                //         clickable: true,
                //         type: "bullets"
                //     },
                //     autoplay:{
                //         delay: 5000,
                //     },
                //     navigation: {
                //         nextEl: '.icon-right',
                //         prevEl: '.icon-left',
                //     },
                // },
            }
        },
        components: {
            Item
        },
        mounted() {
            //新闻轮播
            // this.$api.news.getCompanyDynamics({
            //     pageSize: 10,
            //     pageNo: 0,
            //     type:1
            // }).then(res=>{
            //     this.bannerImgs = res.rows || [];
            // });

            //新闻列表
            this.$api.news.getCompanyDynamics({
                pageSize: 100,
                pageNo: 0,
                type: 1
            }).then(res => {
                this.newslist = res.rows || [];

            });
        }
    }
</script>

<style lang="scss" scoped>
    .list {
        @include clearfix;
    }

    .row {
        display: flex;
        flex-direction: row;
        justify-items: center;
        align-items: center;
    }

    /*媒体报道轮播部分*/
    .newsswiper {
        width: 100%;
        height: 728px;
        background: #FAFAFA;
        position: relative;

        .poster {
            width: 616px;
            height: 728px;
            background: url("../../assets/img/news/bg.png");
            background-position: center;
            background-size: cover;
            position: absolute;
            right: 0;

        }

        .newsbanner {
            width: 1200px;
            height: 435px;
            background: #ffffff;
            position: absolute;
            top: 147px;

            .img {
                width: 491px;
                height: 435px;
                background-size: cover;
                background-position: center;
                flex-shrink: 0;

            }

            .content {
                padding: 0px 89px 0 89px;

                .title {
                    font-size: 20px;
                    font-weight: 500;
                    color: $title-color;
                    margin: 0px;
                }

                .date {
                    font-size: $font-size-base;
                    color: #8D8D8D;
                    margin-bottom: 32px;
                }
            }
        }

    }

    /*新闻列表*/
    .list {
        margin: 50px 0 100px 0;
        @include clearfix;

        .news-item {
            width: 50%;
            max-width: 480px;
            display: inline-block;
            float: left;

            &:nth-of-type(2n+0) {
                float: right;
            }
        }
    }

    .icon-left {
        left: -25px;
    }

    .icon {
        position: absolute;
        width: 50px;
        height: 50px;
        top: 50%;
        margin-top: -25px;
        background-color: #fff;
        z-index: 11;
        text-align: center;
        border: 1px solid #007BD8;
        cursor: pointer;
        outline: none;

        &:hover {
            background-color: $primary-color;

            i {
                color: #fff;
            }
        }

        i {
            font-size: 32px;
            color: #007BD8;
            line-height: 50px;
        }
    }

    .icon-right {
        @extend .icon;
        position: absolute;
        top: 50%;
        margin-top: -25px;
        right: -25px;
    }
</style>
<style>
    .swiper-pagination-bullet-active {
        border: 3px solid #A0A0A0;
        background: #007aff;
    }

    <!--
    新闻列表组件修改-- >
    .news .left {
        width: 70px;
        text-align: center;
    }

    .news .left .day {
        margin: auto;
    }

    .item .right .title {
        max-width: 363px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .news .right .from {
        @extend .item .right .title
        }

    .news .list .news-item {
        margin: 2px;
    }


</style>